import React from "react";
import {
  List,
  Edit,
  Create,
  Datagrid,
  TextField,
  EditButton,
  DisabledInput,
  SimpleForm,
  TextInput,
  Show,
  ShowButton,
  SimpleShowLayout,
  Pagination,
} from "react-admin";

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100, 200]} {...props} />
);
export const StationList = (props) => (
  <List perPage={25} pagination={<PostPagination />} {...props}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="location" label="Ville" />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

const StationTitle = ({ record }) => (
  // eslint-disable-next-line
  <span>Station {record ? `"${record.location}"` : ""}</span>
);

export const StationEdit = (props) => (
  <Edit title={<StationTitle />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <TextInput source="location" label="Ville" />
    </SimpleForm>
  </Edit>
);

export const StationCreate = (props) => (
  <Create title="Créer une station" {...props}>
    <SimpleForm>
      <TextInput source="location" label="Ville" />
    </SimpleForm>
  </Create>
);

export const StationShow = (props) => (
  <Show title={<StationTitle />} {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="location" label="Ville" />
    </SimpleShowLayout>
  </Show>
);



// WEBPACK FOOTER //
// ./src/components/stations.js